import React, { useState, useEffect } from 'react';
import { Upload, Button, List, Row, Col } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom'; // Importer useParams

import { useDocuments } from '../../../context/DocumentsContext';

import ArborescenceDocuments from "../../../components/Documents/ArborescenceDocuments";


import '../DocumentsGlobal.css';
import Loading from '../../../components/Loading/Loading';
import FileExplorer from "../../../components/Documents/FileExplorer";
import NoDocuments from "../NoDocuments";

const DocumentsParents = () => {
    const { documents, forceUpdate, quota, error } = useDocuments();

    if (error) {
        return (
            <Row justify="center" gutter={[16, 16]}>
                <Col xs={24} md={18} lg={14} xl={10}>
                    <NoDocuments
                        isAssistantMaternel={true}
                        context="personnel"
                        message={error}
                        forceUpdate={forceUpdate}
                        subMessage={"Essayez de recharger ou contactez le support si le problème persiste."}
                    />
                </Col>
            </Row>
        );
    }

    // Récupérer uniquement le répertoire global pour affichage
    const repertoireGlobal = documents?.contient.find(
        (item) => item["nom du répertoire"] === "Personnel"
    );

    // Combiner dossiers et fichiers en une seule liste
    const combinedData = [
        ...(repertoireGlobal?.contient || []), // Dossiers
        ...(repertoireGlobal?.fichiers || [])  // Fichiers
    ];

    if(!documents) {
        return <Loading />;
    }
    else if (!documents) {
        return (
            <Row justify="center" gutter={[16, 16]}>
                <Col xs={24} md={18} lg={14} xl={10}>
                    <NoDocuments isAssistantMaternel={true} context="personnel" forceUpdate={forceUpdate} />;
                </Col>
            </Row>
        )
    }

    return (
        <div className="documentContent">
            <Row justify="space-around" align="middle">
                <Col xs={24} sm={24} md={24} lg={22} xl={22} className="documentsCol">
                    {/* Utilisation de FileExplorer pour afficher les fichiers et dossiers du répertoire global */}
                    <FileExplorer
                        data={combinedData}
                        rootFolderName={repertoireGlobal["nom du répertoire"]}
                        rootFolderId={repertoireGlobal.id}
                        rootSize={repertoireGlobal.taille}
                        forceUpdate={forceUpdate}
                        quota={quota}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default DocumentsParents;
